import axiosInstance from "../utils/axiosInstance";

export interface BrandAward {
  id: string;
  title: string;
  position: number;
  category?: "award" | "association_membership";
  image?: {
    original?: string;
    thumb?: string;
  };
}

interface BrandAwardPayload {
  id: string;
  attributes: {
    title: string;
    position: number;
    category?: "award" | "association_membership";
    images?: {
      original?: string;
      thumb?: string;
    };
  };
}

class BrandAwardsApi {
  getAwards(): Promise<BrandAward[]> {
    return axiosInstance.get("/b2c2b/api/v1/brand_awards")
      .then(response => (
        response.data.data.map((award: BrandAwardPayload) => ({
          id: award.id,
          title: award.attributes.title,
          position: award.attributes.position,
          category: award.attributes.category,
          image: award.attributes.images,
        }))
      ));
  }
}

export default new BrandAwardsApi();
